export default [
  'Adamant',
  'Bashful',
  'Bold',
  'Brave',
  'Calm',
  'Careful',
  'Docile',
  'Gentle',
  'Hardy',
  'Hasty',
  'Impish',
  'Jolly',
  'Lax',
  'Lonely',
  'Mild',
  'Modest',
  'Naive',
  'Naughty',
  'Quiet',
  'Quirky',
  'Rash',
  'Relaxed',
  'Sassy',
  'Serious',
  'Timid'
]
